import { useMemo } from 'react';
import { useCurrentSearchState } from 'controllers/SearchController/hooks/useCurrentSearchState';

const useHasFilterApplied = ({
    includeType = false,
}: {
    includeType?: boolean;
}) => {
    const {
        bpmlowerbound,
        bpmupperbound,
        genres,
        instruments,
        keyquality,
        keyrootnote,
        sfxs,
        tags,
        textsearch,
        type,
    } = useCurrentSearchState();

    const hasFilterApplied = useMemo(
        () =>
            !!bpmlowerbound ||
            !!bpmupperbound ||
            !!genres ||
            !!instruments ||
            !!keyquality ||
            !!keyrootnote ||
            !!sfxs ||
            !!tags ||
            !!textsearch ||
            (includeType && !!type),
        [
            genres,
            instruments,
            bpmlowerbound,
            bpmupperbound,
            keyquality,
            keyrootnote,
            textsearch,
            sfxs,
            tags,
            type,
            includeType,
        ],
    );

    return hasFilterApplied;
};

export default useHasFilterApplied;
